const Footer = () => {
    return <footer className={'footer'}>
        <p>2021 LDA Staff Engagement Team  |  Contact us at hkt-theclub@pccw.com</p>
    </footer>
}

export default Footer;